export const ACTION_TYPES = {
    UPDATE_LOCATION: '@@location_picker/UPDATE_LOCATION',
    TRACK_PREDICTION_SELECT: '@@location_picker/TRACK_PREDICTION_SELECT',
    TRACK_TEXT_BOX_CHANGE: '@@location_picker/TRACK_TEXT_BOX_CHANGE',
    TRACK_TEXT_BOX_FOCUS: '@@location_picker/TRACK_TEXT_BOX_FOCUS',
};

export const TRACKING_CONSTANTS = {
    DEFAULT_SECTION: 'LocationAutocomplete',
    LOCATION_PICKER: 'LocationPicker',
    LOCATION_FIELD: 'LocationField',
    LOCATION_QUERY: 'LocationQuery',
    LOCATION_AUTOCOMPLETE: 'LocationAutocomplete',
    USER: 'user',
    CLICK: 'click',
    TYPE: 'type',
};
